import { getWidthToOffset } from './get-width-to-offset';

export const getSlideOffset = ({
	rank,
	i,
	widths,
	reversedWidths,
	centeredSlides,
}) => {
	let widthOffset;

	if (rank >= 0) {
		const clonedWidths = [...widths, ...widths]; // Needed in case rank is bigger than items.length

		widthOffset = getWidthToOffset(clonedWidths, rank);
	} else {
		const clonedWidths = [...reversedWidths, ...reversedWidths]; // Needed in case rank is bigger than items.length

		widthOffset = getWidthToOffset(clonedWidths, Math.abs(rank), -1);
	}

	// If centered slides, position of the slide is moved to the center of the window - half of the slide width
	if (centeredSlides) {
		return widthOffset + window.innerWidth / 2 - widths[i] / 2;
	}

	return widthOffset;
};
